// test1318
(1318 && 0);
